import { render } from "./AdminProductos.vue?vue&type=template&id=2dbaa60f"
import script from "./AdminProductos.vue?vue&type=script&lang=js"
export * from "./AdminProductos.vue?vue&type=script&lang=js"

import "./AdminProductos.vue?vue&type=style&index=0&id=2dbaa60f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__